import { formatTRY } from '../../utils/money'
import './BalanceAfter.css'

/**
 * Cari bakiyenin önce ve sonrası (2 Kas 2026). Bakiye pozitifse borç,
 * negatifse alacak (avans): müşteri önden para bıraktıysa cari satış bu
 * alacaktan düşer, tahsilat borçtan fazlaysa fazlası alacak olur.
 */
export function BalanceAfter({ before, after }: { before: number; after: number }) {
  return (
    <dl className="balafter">
      <div>
        <dt>Şimdiki bakiye</dt>
        <dd className={tone(before)}>{text(before)}</dd>
      </div>
      <div>
        <dt>Sonra</dt>
        <dd className={tone(after)}>{text(after)}</dd>
      </div>
      {before < 0 && after > before && (
        <p className="balafter__note">
          {after <= 0
            ? `${formatTRY(after - before)} alacağından düşülür.`
            : `${formatTRY(-before)} alacağından düşülür, kalan ${formatTRY(after)} borç yazılır.`}
        </p>
      )}
      {after < 0 && after < before && (
        <p className="balafter__note">
          {before > 0
            ? `Borç kapanır, fazlası ${formatTRY(-after)} alacak (avans) olarak kalır.`
            : `${formatTRY(before - after)} avans eklenir, sonraki cari satışlardan düşülür.`}
        </p>
      )}
    </dl>
  )
}

function text(k: number) {
  if (k === 0) return 'Hesap kapalı'
  return k > 0 ? `${formatTRY(k)} borç` : `${formatTRY(-k)} alacaklı`
}

function tone(k: number) {
  return k > 0 ? 'is-owed' : k < 0 ? 'is-credit' : ''
}
